export const EXTERNAL_SIGNER_VALUE = "__external__";

function parse_positive_number(value) {
    const parsed = Number(value || 0);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function build_parse_error_response(error) {
    return {
        status: "error",
        message: error?.message || "Invalid JSON response received from the server."
    };
}

export const first_non_empty_number = (...values) => {
    for (const value of values) {
        const parsed = parse_positive_number(value);
        if (parsed) {
            return parsed;
        }
    }
    return null;
};

export const parse_response_data = (payload) => {
    if (typeof payload !== "string") {
        return payload;
    }

    const trimmed = payload.trim();
    if (!trimmed) {
        const empty_payload = {};
        return empty_payload;
    }

    try {
        return JSON.parse(trimmed);
    } catch (error) {
        return build_parse_error_response(error);
    }
};

export const set_busy_state = (vm, is_busy) => vm.$emit("busy-change", Boolean(is_busy));

export const reset_runtime_state = (vm) => {
    vm.load_error = "";
    vm.signer_configuration = null;
    vm.workflow_assignment_id = null;
    vm.workflow_id = null;
    vm.workflow_name = "";
    vm.workflow_steps = [];
    vm.signer_slots = [];
    vm.notify_in_order = true;
    vm.signing_method = "electronic";
};
